import { StyleSheet, Text, TextProps } from "react-native";

import { kColors } from "src/kColors";

export const PdFieldset: React.FC<TextProps> = ({ style, ...rest }) => (
  <Text style={[styles.pdFieldset, style]} {...rest} />
);

export const PdFormLabel: React.FC<TextProps> = ({ style, ...rest }) => (
  <Text style={[styles.pdFormLabel, style]} {...rest} />
);

const styles = StyleSheet.create({
  pdFieldset: {
    color: kColors.brandDark,
    fontFamily: "Poppins",
    fontWeight: "300",
    letterSpacing: 1.1,
    lineHeight: 25,
  },
  pdFormLabel: {
    color: kColors.brand300,
    fontFamily: "Raleway",
    fontSize: 10,
    fontWeight: "600",
    letterSpacing: 1,
    lineHeight: 18,
    textTransform: "uppercase",
  },
});
